import { useSearchController } from 'controllers/SearchController/SearchContext';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { AudioConfigParams } from 'types/params';

export const useAutoPlay = ({
    rowIndex,
    handlePlay,
}: {
    rowIndex?: number;
    handlePlay: (type: 'toggle' | 'start') => void;
}) => {
    const { search } = useLocation();
    const urlSearchParams = new URLSearchParams(search);

    const { samplesPerPage } = useSearchController();
    const autoPlay = urlSearchParams.get(AudioConfigParams.autoPlay);

    useEffect(() => {
        const isFirstRowAutoplay = autoPlay === 'first' && rowIndex === 0;
        const isLastRowAutoplay =
            autoPlay === 'last' && rowIndex === samplesPerPage - 1;

        if (isFirstRowAutoplay || isLastRowAutoplay) {
            handlePlay('start');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
